/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$( document ).ready(function() {
	var mobileDevices = $(window).width() < 1000;	
  
  	// product configurator
  	function updateConfiguratorDots(index) {
  		$('.product-configurator__steps > .step').css('display', 'none');
        $('.product-configurator__steps > .step').eq(index).fadeIn();        
        $('.product-configurator__dots > .dot').eq(index).addClass('active');
  	}
  	
	$('.step__option').click(function() {
       $(this).siblings().removeClass('active');
       $(this).addClass('active');
	});
  
  	$('.step__btn').click(function() {
       var actualStep = $(this).closest('.step');
       var nextStepIndex = actualStep.index() + 1;
       updateConfiguratorDots(nextStepIndex);
       actualStep.css('display', 'none');
       setTimeout(function() {
       	//actualStep.next().fadeIn();
       }, 1200);	       
       if (mobileDevices) {
          $('html, body').animate({
           scrollTop: $("#product-configurator").offset().top -120
          }, 1000);
       }       
	});
  
  	$('.product-configurator__dots > .dot').click(function() {
      if($(this).hasClass('active')) {
        $(this).nextAll().removeClass('active');
      	var dotIndex = $(this).index();
       	updateConfiguratorDots(dotIndex);
      }
	});
  
  	$('.step__btn--last-step').click(function() {
      var inputTagVal = "";  
      $('.product-configurator__dots').css('display', 'none');
      $('.results-items').addClass('loading');  
      
      function numberBetween(x, min, max) {
        return x >= min && x <= max;
      }
      
      //serialize configurator options fields
      var tagQuery = "";
      $('.step__option.active').each(function(){
      	tagQuery += $(this).data('value') + " AND ";
      });
      
      //serialize configurator input fields
      $('.step__group > input').each(function(){
        var inputType = $(this).data('type');
        var inputTagNumberVal = parseInt($(this).val());    
        // filter tags arrays
        function filterByTagType(value) {
          return value.indexOf(inputType) !== -1;
        }             
        var filteredAllTagsList = allTagsList.filter(filterByTagType);
        console.log(filteredAllTagsList);
                      
        function generateTagQuery(element, index, array) {
          	var inputTagValues = element.split(":");
            var inputTagValues = inputTagValues[1].split("-");
            var minVal = inputTagValues[0];
            var maxVal = inputTagValues[1];
            if (numberBetween(inputTagNumberVal, inputTagValues[0], inputTagValues[1])) {
              console.log(inputType + " -> " + inputTagNumberVal + ": Tag match!");                                          
              if (index === array.length - 1){ 
                  tagQuery += element + " AND ";
              }else{
              	  tagQuery += element + " OR ";
              }
            }else{
              // if (index === array.length - 1){ 
              //     tagQuery += "no-match AND ";
              // }else{
              // 	  tagQuery += "no-match OR ";
              // }
            }
        }
        filteredAllTagsList.forEach(generateTagQuery);              
      });
      
      tagQuery = tagQuery.slice(0,-1);   
      console.log(tagQuery);

      $.getJSON("/search/suggest.json", {
        //"q": "Codzien AND Suwak AND __waist:120-160 OR __waist:80-150 AND __height:150-180 OR __height:160-200",
        "q": tagQuery,
        "resources": {
          "type": "product",
          "limit": 24,
          "options": {
            "fields": "tag"
          }
        }
      }).done(function(response) {
        var productSuggestions = response.resources.results.products;

        if (productSuggestions.length > 0) {
		  //console.log(productSuggestions);
          var productResults = "";
          for (var i = 0; i < productSuggestions.length; i++) {
            productResults += '<div class="item" style="display: none;">';
            	productResults += '<a href="' + productSuggestions[i].url + '">';
              		productResults += '<img class="item__img" src="' + productSuggestions[i].featured_image.url + '" alt="img">';
                	productResults += '<span class="item__title">' + productSuggestions[i].title + '</span>';
                	productResults += '<span class="item__price">' + productSuggestions[i].price + '</span>';
              	productResults += '</a>';
              productResults += '</div>';
          }
          //console.log(productResults);
          $('.results-items').empty().html(productResults);
          
          setTimeout(function() {
            $('.results-items').removeClass('loading').children().fadeIn();
          }, 1000);
                 
        }else{
            $('.step__found-results').css('display', 'none');
        	$('.step__no-results').fadeIn();
        }
      });      
	});    
  
  	$('.step__minus').click(function() {
       var inputVal = parseInt($(this).siblings('.step__group').children('input').val());
       if(inputVal !== 0 && inputVal !== "") {
          inputVal--;
       	  $(this).siblings('.step__group').children('input').val(inputVal);
       } 		
	});
  
  	$('.step__plus').click(function() {
       var inputVal = parseInt($(this).siblings('.step__group').children('input').val());
       if(inputVal < 250) {
          inputVal++;
       	  $(this).siblings('.step__group').children('input').val(inputVal);
       } 		
	});
  
  	$('.step__input-num').on('keydown keyup change', function(e){
      	//var reg = new RegExp("/[^\/0-9]/g");
      	if ($(this).val() === "") { 
           $(this).val(0);	
        }
      
      	//keycode for delete and backspace
      	if ($(this).val() > 250 && e.keyCode !== 46 && e.keyCode !== 8 || $(this).val().length > 3) { 
           e.preventDefault();
           $(this).val(250);
        }
      
        if ($(this).val() < 0) { 
           e.preventDefault();
           $(this).val(0);
        }
    });

 
  
  
  
  	
     
  
});